<div class="d-flex flex-auto flex-row align-items-center item-container">
  <div class="first-col">
    <div class="d-flex flex-auto flex-row">
      <img src="'assets/images/No_Image.png'" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" class="exposure-img" width="100%">
      <div class="d-flex flex-column post-data-placeholder">
        <span class="m-line">-</span>
        <span class="second-line">-</span>
      </div>
      <div class="d-flex flex-auto flex-row justify-content-end">
        <div class="question-mark">
          <img src="assets/images/question-mark.png" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" width="21px" height="21px">
        </div>
      </div>
    </div>
  </div>
  <div class="second-col">
    <div class="main-line">-</div>
  </div>
  <div class="third-col">
    <div class="main-line">-</div>
  </div>
  <div class="fourth-col">
    <div class="main-line">- %</div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/latest-posts-placeholder/latest-post-item-placeholder/latest-post-item-placeholder.component.html